/**
 * Hover-open behaviour for mega menu items on desktop.
 * Only activates at ≥990px (same breakpoint Dawn uses to show the inline nav).
 * Click/keyboard behaviour from HeaderMenu is fully preserved.
 */
(function () {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const CLOSE_DELAY_MS = 120;

  let closeTimer = null;

  function cancelClose() {
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  function openMenu(details) {
    if (details.hasAttribute('open')) return;
    // Close any other open mega-menu first
    document.querySelectorAll('header-menu details[open]').forEach((d) => {
      if (d !== details) closeMenu(d);
    });
    details.setAttribute('open', '');
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  function closeMenu(details) {
    if (!details.hasAttribute('open')) return;
    details.removeAttribute('open');
    details.querySelector('summary').setAttribute('aria-expanded', 'false');
  }

  function init() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;

      menu.addEventListener('mouseenter', () => {
        if (!DESKTOP.matches) return;
        cancelClose();
        openMenu(details);
      });

      menu.addEventListener('mouseleave', () => {
        if (!DESKTOP.matches) return;
        cancelClose();
        closeTimer = setTimeout(() => closeMenu(details), CLOSE_DELAY_MS);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
